import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import { tokens } from '../../theme';
import { useTheme, CircularProgress} from '@mui/material';
import SimpleForm from './resume-kit-voucher-form';
import { useState, useEffect } from 'react';

import { djangoApi } from '../../utils/axios/axios.utils';

import toast from "react-hot-toast";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const VoucherModalForm = ({showModal, setShowModal, dataToEdit, setVoucherData}) =>  {

    const theme = useTheme();
	const colors = tokens(theme.palette.mode);
    
    const [formData, setFormData] = useState({
        tipo: "",
        value: "",
    });

    const [isValidForm, setIsValidForm] = useState(false);
    const [isLoadingVoucher, setIsLoadingVoucher] = useState(false);

    const registerVoucherKit = async (formData) => {
        setIsLoadingVoucher(true)
        try {
            const response = await djangoApi
                .post("products/kit_voucher/update_and_create_kit_voucher/", formData, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            console.log('response here', response)
            const data = {
                data: response?.data?.data,
                status: response.status
            }
            return data
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoadingVoucher(false)
        } finally {
            // pass
            setIsLoadingVoucher(false)
        }
    };

    useEffect(() => {
        if(formData.tipo !== "" && (formData.value !== "" && formData.value !== 0) ){
            setIsValidForm(true)
        } else {
            setIsValidForm(false)
        }
    }, [formData]);

    const handleClose = () => {
        setFormData({
            tipo: "",
            value: "",
        })
        setShowModal(false);
        
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newObj = {
            ...formData, 
            kit_number: dataToEdit.kit_number,
            kit_pk: dataToEdit.kit_pk
        }
        const data = await registerVoucherKit(newObj)
        
        if(data.status === 201){
            setVoucherData(data.data)
            setFormData({
                tipo: "",
                value: "",
            })
            toast.success(
                `${newObj.tipo} incluído com sucesso!!`,
                {
                    position: 'top-right'
                }
            );
            setShowModal(false);
        } else {
            toast.error(
                `Problema em Salvar o ${newObj.tipo}!!`,
                {
                    position: 'top-right'
                }
            );
        }
    };

    return (
        <React.Fragment>
            <Dialog
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    minHeight: '300px'
                }}
            >
                <DialogTitle
                sx={{
                    backgroundColor: colors.pink[600]
                }}
                >{"Adicionar algum tipo de Voucher?"}</DialogTitle>
                <DialogContent
                sx={{
                    backgroundColor: colors.pink[600]
                }}
                >
                    <DialogContentText id="alert-dialog-slide-description">
                        <SimpleForm 
                        colors={colors}
                        handleSubmit={handleSubmit}
                        setFormData={setFormData}
                        formData={formData}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                sx={{
                    backgroundColor: colors.pink[600]
                }}
                >
                    <Button onClick={handleClose} variant="contained" color='warning'>Cancelar</Button>
                    <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color='success'
                    disabled={!isValidForm}
                    startIcon={isLoadingVoucher ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {isLoadingVoucher ? "Salvando..." : "Salvar"}
                        </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}


export default VoucherModalForm